import { TranslateService } from '@ngx-translate/core';

export function getTranslation(translatable: Dictionary<string>, translateService: TranslateService): string {
  const lang: string = translateService.currentLang;
  const translation: string = translatable ? translatable[lang] || '' : '';
  return translation;
}
